import { useStyles } from "../../context/stylesContext";
import { DEFAULT_BACKGROUND_IMAGE } from "../../common/backgrounds";
import styles from "./style.module.css";

/**
 * Фон приложения: PNG 1000×1000 на чёрном (#000).
 * Слой фиксированного размера, `background-size: cover` — картинка не сжимается
 * (не contain). Картинку задаёт BackgroundSync через `backgroundImage` в контексте.
 */
const AppBackground = () => {
  const { styles: bg } = useStyles();

  const src = bg.backgroundImage ?? DEFAULT_BACKGROUND_IMAGE;
  const bottom = bg.bottom ?? "0";
  const opacity = bg.opacity ?? "1";

  return (
    <div
      className={styles.root}
      style={{ bottom, opacity }}
      aria-hidden
    >
      <div
        key={src}
        className={styles.frame}
        style={{ backgroundImage: `url(${src})` }}
      />
    </div>
  );
};

export default AppBackground;
